var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAssignTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.125 59.4375C72.125 48.6367 80.875 39.75 91.8125 39.75C94.4102 39.75 96.8711 40.2969 99.0586 41.2539L87.4375 52.875V63.8125H98.375L109.996 52.1914C110.953 54.3789 111.5 56.8398 111.5 59.4375C111.5 67.9141 106.168 75.0234 98.7852 77.8945L92.6328 71.7422L89.625 68.5977L86.4805 71.7422L85.3867 72.8359L72.125 59.5742V59.4375ZM41.5 96.625L64.4688 73.6562L74.4492 83.6367L73.3555 84.8672L70.2109 87.875L73.3555 91.0195L54.625 109.75L41.5 96.625ZM60.2305 95.5312L55.7188 91.0195L51.0703 95.5312L55.7188 100.18L60.2305 95.5312ZM80.7383 83.6367L63.1016 66H54.625L41.5 48.5L50.25 39.75L67.75 52.875V61.4883L85.3867 78.9883L89.625 74.75L111.5 96.625L98.375 109.75L76.5 87.875L80.7383 83.6367Z",
    fill: "url(#paint0_linear_16110_376623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16110_376623",
    x1: 76.5,
    y1: 64,
    x2: 76.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAssignTicket);
export default __webpack_public_path__ + "static/media/img_assign_ticket.ab661e68f6c96f5b7fb3fd6985a1273a.svg";
export { ForwardRef as ReactComponent };